<template>
  <div class="w-full">
    <a v-if="!isVisible" class="w-8 h-8 rounded-full bg-button-color-green flex items-center justify-center text-white"
      href="javascript:void(0)" click="addNewRecipe(element, index, 'mon')"><i class="fa fa-plus" @click="showModal()"
        aria-hidden="true"></i>
    </a>
    <div v-if="isVisible" class="relative flex gap-1 w-full z-[999]">

      <div class="relative flex justify-between w-full">
        <div class="relative w-full">
          <input class=" shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded w-full input-background"
            type="text" id="mc_option_recipe_search" v-model="optionSearchRecipeName" @input="
              mc_option_recipe_search_method(
                optionSearchRecipeCat,
                $event
              )
              " placeholder="Search Recipe" />
          <span v-if="showSearchBoxCancel" class="
          flex
          items-center
          justify-center
          bg-transparent
          text-black
          opacity-100
          h-6
          w-6
          text-2xl
          block
          outline-none
          focus:outline-none
          cursor-pointer
          absolute
          top-0
          right-0
          mt-1
        " @click="cancelRecipeSearchValue">x</span>
          <div class="
          absolute
          bg-white
          max-w-2xl
          overflow-x-auto
          w-full
          max-h-150
        ">
            <div v-for="searched_recipe in searched_recipes" class="py-1 px-3 cursor-pointer hover:bg-gray-100"
              @click="selectRecipesIdToAdd(searched_recipe)">
              {{ searched_recipe.custom_id }} -
              {{ searched_recipe.name
              }}{{ searched_recipe.is_favorite ? " - Favorite" : "" }}
            </div>
          </div>
        </div>
      </div>


      <div class="">

        <div class="flex
  items-center
  justify-end">
          <!-- <span class="
    text-green-500
    bg-transparent
    border border-solid border-green-500
    hover:bg-green-500 hover:text-white
    active:bg-green-600
    font-bold
    uppercase
    text-sm
    px-3
    py-2
    rounded
    outline-none
    focus:outline-none
    mr-1
    mb-1
    ease-linear
    transition-all
    duration-150 cursor-pointer" v-if="showSearchBoxCancel" @click="addRecipe()">Add Recipe</span> -->

          <span class="
    text-red-500
    bg-transparent
    border border-solid border-red-500
    hover:bg-red-500 hover:text-white
    active:bg-red-600
    font-bold
    uppercase
    text-sm
    px-3
    py-2
    rounded
    outline-none
    focus:outline-none
    mr-1
    mb-1
    ease-linear
    transition-all
    duration-150 cursor-pointer
  " @click="closeModal">x</span>

        </div>

      </div>

    </div>
  </div>
</template>

<script>

import { Inertia } from "@inertiajs/inertia";
import vClickOutside from "click-outside-vue3";
import OptionReplacePopUpPreview from "@/Pages/MenuCycle/OptionReplacePopUpPreview";

export default {
  props: [
    'element',
    'index',
    'day'
  ],

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    OptionReplacePopUpPreview
  },
  name: "large-modal",
  data() {
    return {
      isVisible: false,
      title: 'Add New Recipe',
      optionSearchRecipeName: '',
      searchRecipe: null,
      showSearchBoxCancel: false,
      debounce: null,
      searched_recipes: [],
      attached_recipe_object: [],
      is_whole_week: false
    };
  },

  methods: {
    closeModal() {
      this.isVisible = false;
      // this.$emit('closeOptionPopup');
    },
    showModal() {
      this.optionSearchRecipeName = '';
      this.searchRecipe = null;
      this.attached_recipe_object = [];
      this.searched_recipes = [];
      this.showSearchBoxCancel = false;

      this.isVisible = true;


      // this.$emit('closeOptionPopup');
    },
    addRecipe() {
      console.log('makeAddRecipe', this.attached_recipe_object);

      this.$emit('makeAddRecipe', this.attached_recipe_object, { elementArray: this.element, indexKey: this.index, dayName: this.day });

      console.log('makeAddRecipe 1', this.attached_recipe_object);
      setTimeout(() => {
        this.$toast.success("The recipe has been added!");
        // this.$emit('closeOptionPopup');
        this.closeModal();
      }, 100);
    },
    selectRecipesIdToAdd(recipeObj) {
      this.optionSearchRecipeName = recipeObj.name;
      this.searchRecipe = recipeObj;
      this.attached_recipe_object = recipeObj;
      this.searched_recipes = [];
      this.showSearchBoxCancel = true;
      this.addOptionRecipeButton();

    },


    mc_option_recipe_search_method(SearchRecipeCat, e) {
      let $this = this;
      let search_term = e.target.value;
      this.$toast.clear();
      clearTimeout(this.debounce)
      if (search_term == "") {
        this.searched_recipes = [];
        this.$toast.error("Error: Search value required!");
        // } else if (SearchRecipeCat == "") {
        //   this.searched_recipes = [];
        //   this.$toast.error("Error: Select Recipe Category!");
      } else {
        this.debounce = setTimeout(() => {
          axios
            .post("/menu-cycle-recipes-search-modal", {
              term: search_term,
              recipeCat: SearchRecipeCat,
            })
            .then((response) => {
              $this.searched_recipes = [];
              $this.searched_recipes = response.data;
            })
            .catch((error) => console.error(error));
        }, 900);

      }
    },
    cancelRecipeSearchValue() {
      this.optionSearchRecipeName = "";
      this.showSearchBoxCancel = false;
    },
    addOptionRecipeButton() {
      //console.log('1',this.ing_recipes_prefer_products);
      this.$toast.clear();
      let $this = this;
      if (this.attached_recipe_object.length == 0) {
        this.$toast.error("Error: Select Recipe to add!");
      } else {
        console.log("this.attached_recipe_object", this.attached_recipe_object);
        this.attached_recipe_object.is_override = false;
        this.attached_recipe_object.total_val_override =
          $this.$helpers.getBlankObject();

        axios
          .get("/get-recipe-total-vals/" + this.attached_recipe_object.id)
          .then((response) => {
            if (response.data) {
              $this.attached_recipe_object.all_prefer_products = response.data;
              $this.attached_recipe_object.total_val =
                $this.$helpers.sum_products_week_popup_totals_new(
                  response.data
                );

              setTimeout(() => {
                $this.addRecipe();
              }, 100);
            }
          })
          .catch((error) => console.error(error));
      }
    },
  },
};
</script>

<style>
.searching-background-color {
  background-color: #38558e;
}

.button-bg-color-wed-menu2-gray {
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.button-bg-color-wed-menu2 {
  background-color: #38558e;
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.menu1-icon-color {
  color: #38558e;
}

.cancel-background-color {
  background-color: #8b8b8b;
}

.placeholder-background-color {
  background-color: #f8f8f8;
}

.mt-0-down {
  margin-top: -54px;
}

.button-bg-color-wed-menu1 {
  background-color: #cbcbcb45;
}

.text-color-first-li {
  color: #38558e;
}

.icon-star-color {
  color: #f7a53a;
}

.th-heading-background {
  background-color: #f4f4f4;
}

.button-bg-color-wed {
  background-color: #cbcbcb;
}

.input-background {
  background-color: #f8f8f8;
}

.white-shadow-box {
  box-shadow: 0px 2px 5px #0000005e;
}

.bg-button-color {
  background-color: #cb0000;
}

.min-w-min-button {
  min-height: 26px;
  min-width: 53px;
}

.max-w-0-menu1 {
  max-width: 4rem;
}

.bg-button-color-green {
  background-color: #22af4b;
}

.bg-button-color-gray {
  background-color: #636363;
}

.bg-hard-grey {
  background-color: #f4f4f4;
}

.min-w-min-button-menu1 {
  min-height: 27px;
  min-width: 26px;
  border: 1px solid lightgrey;
}

#inputUpload {
  display: none;
}

.custom-file-upload {
  cursor: pointer;
  font-size: inherit;
  color: #0c090d;
}

.min-h-full-menu1 {
  min-height: 200px;
}

.custom-file-upload:hover {
  text-decoration: underline;
}

.border-property {
  border: 1px solid gray;
  margin-top: 20px;
  border-style: dashed;
  border-bottom: none;
}

.menu1-background-color {
  background-color: #faa43d;
}

.menu1-text-color {
  color: #faa43d;
}

.min-height-third {
  min-height: 400px;
}

.select-menu-height {
  height: 100%;
}

.min-height-fivth {
  min-height: 70px;
}

.icon-position-menu1 {
  position: absolute;
  top: -5px;
  right: 41px;
}

.icon-position-menu2 {
  position: absolute;
  top: -5px;
  right: -3px;
}

.position-cross {
  position: absolute;
  right: -21px;
  top: -25px;
  z-index: 1;
  overflow: auto;
}

/* .w-4/12-h2 {
  width: 29%;
} */

.pt-2-space {
  padding-top: 5px;
}

.-top-px {
  top: -4px;
}

.max-h-650 {
  max-height: 650px;
}

.max-h-150 {
  max-height: 150px;
}

.expand_recipe {
  transform: rotate(180deg);
}

.loader-15 {
  background: currentcolor;
  position: relative;
  animation: loader-15 1s ease-in-out infinite;
  animation-delay: 0.4s;
  width: 0.25em;
  height: 0.5em;
  margin: 37px auto;
}

.loader-15:after,
.loader-15:before {
  content: "";
  position: absolute;
  width: inherit;
  height: inherit;
  background: inherit;
  animation: inherit;
}

.loader-15:before {
  right: 0.5em;
  animation-delay: 0.2s;
}

.loader-15:after {
  left: 0.5em;
  animation-delay: 0.6s;
}

@keyframes loader-15 {

  0%,
  100% {
    box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
  }

  50% {
    box-shadow: 0 -0.25em 0 currentcolor, 0 0.25em 0 currentcolor;
  }
}
</style>
